import axios, { AxiosRequestConfig, ResponseType } from 'axios';

import { checkTokenInterceptor } from './axiosInterceptors';

checkTokenInterceptor();

interface ICredentials {
  URL: string;
}

export class BaseService {
  protected _credentials?: ICredentials;

  protected _prefix: string = '';

  public setCredentials(credentials: ICredentials): void {
    this._credentials = credentials;
  }

  protected getCurrentUrl(path: string): string {
    if (this.credentials) {
      return `${this.credentials.URL}${this.prefix}${path}`;
    }

    return `${this.prefix}${path}`;
  }

  protected get credentials() {
    return this._credentials;
  }

  protected get headers(): { headers: any } {
    const token = localStorage.getItem('access_token');
    if (token) {
      return {
        headers: { Authorization: `Bearer ${token}` },
      };
    }

    return {
      headers: {},
    };
  }

  public set prefix(prefix: string | undefined) {
    this._prefix = prefix || '';
  }

  public get prefix(): string | undefined {
    return this._prefix;
  }

  public async get<T>(route: string) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.get<T>(url, this.headers);
    return result;
  }

  public async getFile<T>(route: string, responseType: ResponseType, customHeaders: any) {
    const url: string = this.getCurrentUrl(route);
    const updatedConfig: AxiosRequestConfig = {
      responseType,
      headers: {
        ...this.headers.headers,
        ...customHeaders,
      },
    };
    const result = await axios.get<T>(url, updatedConfig);
    return result;
  }

  public async post(route: string, data: any, customHeaders = {}) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.post(url, data, {
      headers: { ...this.headers.headers, ...customHeaders },
    });
    return result;
  }

  public async put(route: string, data: any) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.put(url, data, this.headers);
    return result;
  }

  public async patch(route: string, data: any) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.patch(url, data, this.headers);
    return result;
  }

  public async remove(route: string) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.delete(url, this.headers);
    return result;
  }
}
